module.exports = ram;